import styled from 'styled-components'

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
  padding: 0 16px;
`
